export default "__VITE_ASSET__CRXi5sEN__"